import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { InvitedAffiliatesTable } from "../../../components/AffiliateTable/InvitedAffiliatesTable";
import { brandService } from "../../../services/brand.service";
import { Send, Users } from "react-feather";
import { DataTablePagination } from "@/components/ui/data-table";
import PageHeader from "../../../components/common/PageHeader";
import { BulkInviteStatsModal } from "../../../components/BulkInviteStatsModal/BulkInviteStatsModal";
import { Button } from "../../../components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";
import { TableCard } from "@/components/ui/table-card";

export function InvitedAffiliates() {
  const [page, setPage] = useState(1);
  const [showBulkInviteStats, setShowBulkInviteStats] = useState(false);
  const [pageSize, setPageSize] = useState(10);

  const { data, isLoading, error } = useQuery({
    queryKey: ["invited-affiliates", page, pageSize],
    queryFn: () => {
      console.log("Fetching data for page:", page);
      return brandService.getInvitedAffiliates(page, pageSize);
    },
  });

  const totalPages = data?.pagination.totalPages || 0;

  const handlePageChange = (newPage: number) => {
    console.log("Page change requested to:", newPage);
    setPage(newPage);
  };

  return (
    <div className="space-y-6">
      <PageHeader title="Invited affiliates" showDefaultActions={true} />

      <BulkInviteStatsModal
        isOpen={showBulkInviteStats}
        onClose={() => setShowBulkInviteStats(false)}
      />

      <Button variant="outline" className="my-4 bg-brand-100 text-brand-600 hover:bg-brand-200 hover:text-brand-700" onClick={() => setShowBulkInviteStats(true)}>
        <Send className="h-4 w-4" />
        Bulk Invite Stats
      </Button>
      <TableCard>
        {error ? (
          <div className="text-center py-8 text-sm text-red-600">
            Failed to load invited affiliates
          </div>
        ) : !isLoading && !data?.data.length ? (
          <EmptyState
            bordered={false}
            icon={<Users />}
            title="No invited affiliates yet"
            body="When you invite affiliates to join your program, they'll appear here"
          />
        ) : (
          <>
            <InvitedAffiliatesTable
              data={data?.data ?? []}
              isLoading={isLoading}
            />
            <DataTablePagination
              page={page}
              totalPages={totalPages}
              total={data?.pagination.total ?? 0}
              pageSize={pageSize}
              onPageChange={handlePageChange}
              onPageSizeChange={(size) => {
                setPageSize(size);
                setPage(1);
              }}
              pageSizeOptions={[10, 20, 50, 100]}
              noun="invites"
            />
          </>
        )}
      </TableCard>
    </div>
  );
}
